import { api } from "../api/api";
import { fetchBlob } from "@/api/mediaApi";

const API_BASE_URL = api.defaults.baseURL;

export const openAuthenticatedUrl = async (path: string, fileName?: string) => {
    const tab = window.open();
    try {
        const { data, headers } = await fetchBlob(xolaApiUrl(path));
        const disposition = headers["content-disposition"];
        const url = URL.createObjectURL(data);
        if (tab && !isAttachment(disposition)) {
            tab.location = url;
        } else {
            tab?.close();
            downloadBlobUrl(url, contentDispositionFileName(disposition) ?? fileName ?? "");
            setTimeout(() => URL.revokeObjectURL(url));
        }
    } catch (error) {
        tab?.close();
        throw error;
    }
};

export const xolaApiUrl = (url: string) => `${API_BASE_URL}${url}`;

const isAttachment = (disposition?: string) => disposition?.startsWith("attachment") ?? false;

const downloadBlobUrl = (url: string, fileName: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
};

const contentDispositionFileName = (disposition?: string) => disposition?.match(/filename="?([^";]+)"?/)?.[1];
